import React, { useState } from 'react';

/*------------- IMPORTS FROM MATERIAL UI ------------------------------------*/
import { Steps, Panel, IconButton, Message } from 'rsuite';
import { Input, InputGroup } from 'rsuite';
import { InputPicker } from 'rsuite';
import { Uploader } from 'rsuite';
import Stack from 'rsuite/Stack';
import AttachmentIcon from '@rsuite/icons/Attachment';
import SpinnerIcon from '@rsuite/icons/legacy/Spinner';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import DocPassIcon from '@rsuite/icons/DocPass';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';

/*------------- OTHERS ------------------------------------------------------*/
import api from 'Components/_helpers/api';

/*------------- CUSTOM ------------------------------------------------------*/
import { useEmpresas } from 'Components/Common/CustomHooks/useEmpresas';

export default function CertificadoForm() {
  const uploader = React.useRef();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [emisor, setEmisor] = useState({});
  const [cercve, serCerCve] = useState();
  const [visible, setVisible] = React.useState(false);
  const [error, setError] = useState();
  const [empresas, loadingData, featEmpresas] = useEmpresas();

  const handleChange = () => {
    setVisible(!visible);
  };

  const onSelectEmisor = (val, item, event) => {
    if (item) {
      setEmisor(item);
      setStep(1);
    }
  };

  const onSelectFile = (l) => {
    if ((l.length = 1)) {
      setError();
      setFileList(l);
      setStep(2);
    }
  };

  const handleSubmit = () => {
    uploader.current.start();
  };

  const [step, setStep] = React.useState(0);

  return (
    <div>
      {error && (
        <>
          <Message showIcon type="error" header="Error al cargar certificado">
            {error}
          </Message>
          <hr />
        </>
      )}
      <Steps current={step} currentStatus={error ? 'error' : 'process'}>
        <Steps.Item title="Emisor" description="Selecciona el Emisor." />
        <Steps.Item title="Certificado" description="Carga el certificado." />
        <Steps.Item title="Revisión" description="Revisa detalles." />
        <Steps.Item title="Listo" description="Certiicado cargado correctamente." />
      </Steps>
      <hr />
      <Panel style={{ display: ` ${step === 0 ? '' : 'none'}` }}>
        <span>
          Para poder emitir documentos en la plataforma es necesario cargar el certificado de firma electrónica emitido por el ministerio de
          hacienda.{' '}
          <a href="https://factura.gob.sv/2020/09/02/ent1/" target="_blank" rel="noreferrer">
            mas información
          </a>
        </span>
        <hr />
        <InputPicker
          data={empresas}
          placeholder="Selecciona el emisor al que corresponde el certificado"
          block
          
          valueKey="emisor"
          onSearch={featEmpresas}
          onSelect={onSelectEmisor}
          renderMenu={(menu) => {
            if (loadingData) {
              return (
                <p style={{ padding: 10, color: '#999', textAlign: 'center' }}>
                  <SpinnerIcon spin /> Buscando...
                </p>
              );
            }
            return menu;
          }}
        />
      </Panel>
      <Panel style={{ display: ` ${step === 1 ? '' : 'none'}` }}>
        <Uploader
          action={`${api.getUri()}Certificado`}
          headers={{Authorization: `Bearer ${localStorage.getItem('APP_TOKEN')}`}}
          //accept=".cer"
          draggable
          data={{ nit: emisor.value, pass: cercve }}
          fileList={fileList}
          ref={uploader}
          name="files"
          autoUpload={false}
          multiple={false}
          fileListVisible={false}
          onChange={onSelectFile}
          onSuccess={() => setStep(3)}
          onProgress={() => setLoading(true)}
          onError={(r, f) => {
            setStep(1);
            setFileList([]);
            setError(`${fileList[0].name}: ${r.response}`);
          }}
        >
          <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Stack direction="column">
              <AttachmentIcon style={{ fontSize: '4em', marginBottom: 10 }} />
              <span>
                Haz click o Arrastra aquí el certificado de firma electrónica correspondiente al emisor <b>{emisor.label}</b>
              </span>
              <span>
                Deberá ser un archivo de extensión <b>.cer</b> emitido por el ministerio de hacienda.
              </span>
            </Stack>
          </div>
        </Uploader>
      </Panel>
      <Panel style={{ display: ` ${step === 2 ? '' : 'none'}` }}>
        <Stack direction="column">
          <InfoOutlineIcon color="#3498FF" style={{ fontSize: '4em', marginBottom: 10 }} />
          <hr />
          {fileList.length && (
            <span>
              Archivo: <b>{fileList[0].name}</b>
            </span>
          )}
          <span>
            Certificado de firma electrónica correspondiente al emisor <b>{emisor.label}</b>
          </span>
          <hr />
          <span>Ingresa aquí la contraseña del certificado:</span>
          <InputGroup inside style={{ width: 350 }}>
            <Input type={visible ? 'text' : 'password'} onChange={(val, e) => serCerCve(val)} />
            <InputGroup.Button onClick={handleChange}>{visible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
          </InputGroup>
          <hr />
          <IconButton
            icon={<DocPassIcon />}
            disabled={(cercve ? false : true) || error}
            block
            loading={loading}
            appearance="primary"
            onClick={handleSubmit}
          >
            Cargar en la plataforma
          </IconButton>
        </Stack>
      </Panel>
      <Panel style={{ display: ` ${step === 3 ? '' : 'none'}` }}>
        <Stack direction="column">
          <CheckRoundIcon color="green" style={{ fontSize: '4em', marginBottom: 10 }} />
          <hr />
          {fileList.length && (
            <span>
              Archivo: <b>{fileList[0].name}</b> cargado correctamente.
            </span>
          )}
          <span>
            Certificado de firma electrónica correspondiente al emisor <b>{emisor.label}</b>
          </span>
          <hr />
          <span>Ya puedes cerrar esta ventana.</span>
        </Stack>
      </Panel>
      <hr />
    </div>
  );
}
